export default "__VITE_ASSET__9076677a__"